import axios from 'axios'

let mode = process.env.VUE_APP_ENV_MODE

let host, pagehost, pagebase, apppagebase, appId, cookieDomain, educbase
export let viteCosBucket = ''

switch (mode) {
  /*生产环境*/
  case 'production': {
    host = 'https://api.eda365.com/index.php'
    pagehost = 'https://app.eda365.com/pages'
    pagebase = 'https://app.eda365.com/pages/m'
    apppagebase = 'https://app.eda365.com/pages/app'
    appId = 'wx00400b01afe2b8dc' /*巢粉俱乐部*/
    cookieDomain = '.eda365.com'
    viteCosBucket = 'ence-1251541497'
    educbase = 'https://edu.elecnest.com'
    break
  }
  /*测试环境*/
  case 'devbuild': {
    host = 'https://api.elecnest.cn/index.php'
    pagehost = 'http://app.elecnest.cn'
    pagebase = 'http://app.elecnest.cn/m/devtest'
    apppagebase = 'http://app.elecnest.cn/app/devtest'
    appId = 'wx53ee520141e09397' /*袁良的测试公众号*/
    cookieDomain = '.elecnest.cn'
    viteCosBucket = 'ence-test-1251541497'
    educbase = 'http://educ.elecnest.cn'
    break
  }
  /*本地环境*/
  default: {
    host = 'https://api.elecnest.cn/index.php'
    pagehost = 'http://localhost:8080'
    pagebase = 'http://app.elecnest.cn/m/devtest'
    apppagebase = 'http://app.elecnest.cn/app/devtest'
    appId = 'wx682306a1c3aec7f7' /*本地开发人员的测试公众号*/
    cookieDomain = '.elecnest.cn'
    viteCosBucket = 'ence-test-1251541497'
    educbase = 'http://educ.elecnest.cn'
    break
  }
}

const instance = axios.create({
  baseURL: host
})
/*请求拦截*/
instance.interceptors.request.use(config => {
  return config
}, err => Promise.reject(err))
/*响应拦截*/
instance.interceptors.response.use(response => {
  let res = response.data
  if (mode !== 'production') {
    let config = response.config
    console.log(config.url, {
      code: res.code,
      data: res.data,
      res: res,
      params: config.params,
      resHeaders: response.headers
    })
  }
  return res
}, err => Promise.reject(err))

export {
  host,
  pagehost,
  pagebase,
  apppagebase,
  appId,
  cookieDomain,
  educbase
}
export default instance